
import { Base } from '../base-component';

import './icon.component.scss';
import { AxiosPromise } from 'axios';

export class Icon extends Base {

	parser: DOMParser;
	serializer: XMLSerializer;
	gradient: string;
	svg: string;
	assetPath:  string;

	constructor(element: Element) {
		super(element);
	}

	init(){

		this.parser = new DOMParser();
		this.serializer = new XMLSerializer();

		this.gradient = this.element.getAttribute('data-gradient');

		this.setPath();

		this.setIcon(this.element.getAttribute('data-icon'));

	}

	embedSVG(svgElement) {
		this.element.innerHTML = svgElement;
	}

	bindEvents() {}

	setPath() {

		let path = this.element.getAttribute('data-path');

		if (path && path != "") {
			this.assetPath = path + (path[path.length - 1] != '/' ? '/' : '');
		} else if (path === '/assets/icons') {
			this.assetPath = "/file_source/assets/icons/";
		} else {
			this.assetPath = "/file_source/assets/icons/";
		}

	}

	setIcon(icon: string) {

		this.http.get(`${this.assetPath}${icon}.svg`)
			.then( (response) => {

				this.svg = this.setGradient(response.data);

				this.embedSVG(this.svg);

			}

		);

	}

	setGradient(data) {

		let svg = this.parser.parseFromString(data, "text/xml");

		if (this.gradient === 'gradient' && svg.getElementsByTagName("linearGradient")[0]) {

			let svgId = this.generateGuid();

			svg.getElementsByTagName("linearGradient")[0].setAttribute("id", `gradient-${svgId}`);
			svg.getElementsByTagName("path")[0].setAttribute("fill", `url(#gradient-${svgId})`);

			svg.getElementsByTagName("linearGradient")[0].getElementsByTagName("stop")[0].setAttribute("stop-color", "#ff5a00");
			svg.getElementsByTagName("linearGradient")[0].getElementsByTagName("stop")[1].setAttribute("stop-color", "#ffb94f");

		}else if(this.gradient === 'gradient-sponsorship' && svg.getElementsByTagName("linearGradient")[0]) {

			let svgId = this.generateGuid();

			svg.getElementsByTagName("linearGradient")[0].setAttribute("id", `gradient-${svgId}`);
			svg.getElementsByTagName("path")[0].setAttribute("fill", `url(#gradient-${svgId})`);

			svg.getElementsByTagName("linearGradient")[0].getElementsByTagName("stop")[0].setAttribute("stop-color", "#d52552");
			svg.getElementsByTagName("linearGradient")[0].getElementsByTagName("stop")[1].setAttribute("stop-color", "#ae3352");

		}else if(this.gradient === 'gradient-indigo' && svg.getElementsByTagName("linearGradient")[0]) {

			let svgId = this.generateGuid();

			svg.getElementsByTagName("linearGradient")[0].setAttribute("id", `gradient-${svgId}`);
			svg.getElementsByTagName("path")[0].setAttribute("fill", `url(#gradient-${svgId})`);

			svg.getElementsByTagName("linearGradient")[0].getElementsByTagName("stop")[0].setAttribute("stop-color", "#0a2240");
			svg.getElementsByTagName("linearGradient")[0].getElementsByTagName("stop")[1].setAttribute("stop-color", "#0089ff");
			
		}

		return this.serializer.serializeToString(svg);

	}

	generateGuid() {

		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {

			var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
			return v.toString(16);

		});

	}

}



// WEBPACK FOOTER //
// ./components/icon/icon.component.ts